import { CaixaLogoWithTextSvg } from 'libs/shared/ui/src/lib/assets/images/svg/caixa-logo-with-text'
import AcceptanceScreen from 'libs/shared/ui/src/lib/components/zoom/AcceptanceScreen'
import InstruccionesScreen from 'libs/shared/ui/src/lib/components/zoom/InstruccionesScreen'
import MeetingEndedScreen from 'libs/shared/ui/src/lib/components/zoom/MeetingEndedScreen'
import MeetingScreen from 'libs/shared/ui/src/lib/components/zoom/MeetingScreen'
import PermissionsScreen from 'libs/shared/ui/src/lib/components/zoom/PermissionsScreen'
import QidaLogo from 'libs/shared/ui/src/lib/components/zoom/components/IconsComponents/QidaLogo'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router-dom'

const Zoom = () => {
  const { token, page } = useParams<{ token: string; page: string }>()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const brand = searchParams.get('brand') || ''
  const meetingNumber = searchParams.get('meeting_number') || ''
  const password = searchParams.get('password') || ''
  const language = searchParams.get('language') || 'es'
  const roomId = searchParams.get('name') || ''
  const documentTitle =
    brand === 'vidacaixa'
      ? 'VidaCaixa'
      : brand.charAt(0).toUpperCase() + brand.slice(1)
  const startDate = searchParams.get('start_date') || ''
  const endDate = searchParams.get('end_date') || ''
  const { i18n } = useTranslation()

  useEffect(() => {
    if (roomId) {
      localStorage.setItem('zoom_room_id', roomId)
    }
  }, [roomId])

  const updateFavicon = (brand: string) => {
    const favicon = document.querySelector(
      "link[rel~='icon']",
    ) as HTMLLinkElement
    if (favicon) {
      switch (brand) {
        case 'vidacaixa':
          favicon.href = '/assets/images/zoom/vidacaixa-favicon.ico'
          break
        case 'qida':
          favicon.href = '/assets/images/zoom/favicon.ico'
          break
        default:
          favicon.href = '/assets/images/zoom/favicon.ico'
          break
      }
    }
  }

  React.useEffect(() => {
    updateFavicon(brand)
  }, [brand])

  useEffect(() => {
    if (language && i18n.language !== language) {
      i18n.changeLanguage(language)
    }
  }, [language, i18n])

  if (!token) {
    return <div>Error: No se encontró el token</div>
  }
  const renderPageContent = (
    token: string,
    page: string,
    brand: string,
    language: string,
    startDate: string,
    endDate: string,
    meetingNumber: string,
    password: string,
  ) => {
    switch (page) {
      case 'lopd':
        return (
          <AcceptanceScreen
            token={token}
            brand={brand}
            documentTitle={documentTitle}
            language={language}
            startDate={startDate}
            endDate={endDate}
            meetingNumber={meetingNumber}
            password={password}
          />
        )
      case 'meeting':
        return (
          <MeetingScreen
            token={token}
            brand={brand}
            documentTitle={documentTitle}
            meetingNumber={meetingNumber}
            password={password}
            language={language}
            startDate={startDate}
            endDate={endDate}
            userRole={1}
          />
        )
      case 'instrucciones':
        return (
          <InstruccionesScreen
            token={token}
            brand={brand}
            documentTitle={documentTitle}
            language={language}
            startDate={startDate}
            endDate={endDate}
            meetingNumber={meetingNumber}
            password={password}
          />
        )
      case 'meeting-ended':
        return (
          <MeetingEndedScreen
            updateFavicon={updateFavicon}
            documentTitle={documentTitle}
          />
        )

      case 'not-available':
        return null
      case 'permissions':
        return (
          <PermissionsScreen
            token={token}
            brand={brand}
            language={language}
            startDate={startDate}
            endDate={endDate}
          />
        )
      default:
        return <div>Error: Página no encontrada</div>
    }
  }

  return (
    <div className="w-[100%] md:w-full flex flex-col items-center justify-start mt-[130px] text-generic-neutral-900 font-aeonik">
      {page !== 'meeting-ended' &&
        (brand === 'vidacaixa' ? (
          <CaixaLogoWithTextSvg style={{ width: '230px', height: '50px' }} />
        ) : (
          <QidaLogo />
        ))}

      {renderPageContent(
        token,
        page || '',
        brand,
        language,
        startDate,
        endDate,
        meetingNumber,
        password,
      )}
    </div>
  )
}

export default Zoom
